import Vue from 'vue'
import Vue2Filters from 'vue2-filters'

// Use dayjs instead of moment (much smaller)
// Run: npm install dayjs
import dayjs from 'dayjs';

// Import only needed Chart.js components
import {
    Chart,
    LineController,
    LineElement,
    BarController,
    BarElement,
    BubbleController,
    PointElement,
    LinearScale,
    CategoryScale,
    TimeScale,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';

import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import numeral from 'numeral';

// Import only needed BootstrapVue components
import {
    ModalPlugin,
    TablePlugin,
    FormPlugin,
    FormInputPlugin,
    FormGroupPlugin,
    FormSelectPlugin,
    FormDatepickerPlugin,
    ButtonPlugin,
    CardPlugin,
    LayoutPlugin
} from 'bootstrap-vue'

// Install only needed plugins
Vue.use(ModalPlugin);
Vue.use(TablePlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

Vue.component('users-grid', require('./components/UsersGrid.vue').default);
Vue.component('trades', require('./components/Trades.vue').default);
Vue.component('add-trades', require('./components/AddTrades.vue').default);
Vue.component('home-chart', require('./components/HomeChart.vue').default);
Vue.component('security-chart', require('./components/SecurityChart.vue').default);
Vue.component('dividends-chart', require('./components/DividendsChart.vue').default);
Vue.component('trades-summary', require('./components/TradesSummary.vue').default);
Vue.component('trendingstocks', require('./components/TrendingStocks.vue').default);
Vue.component('projected-chart', require('./components/ProjectedChart.vue').default);

Vue.component('indicators', require('./components/Indicators.vue').default);
Vue.component('stocknews', require('./components/News.vue').default);
Vue.component('portfolio-dividends', require('./components/PortfolioDividends.vue').default);
Vue.component('arbitrage-chart', require('./components/ArbitrageChart.vue').default);
Vue.component('daily-pnl', require('./components/DailyPnL.vue').default);
Vue.component('trades-recent', require('./components/TradesRecent.vue').default);

Vue.use(Vue2Filters);
Vue.use(Autocomplete);

// Register only needed Chart.js components
Chart.register(
    LineController,
    LineElement,
    BarController,
    BarElement,
    BubbleController,
    PointElement,
    LinearScale,
    CategoryScale,
    TimeScale,
    Tooltip,
    Legend,
    Filler,
    zoomPlugin
);


Vue.mixin({
    computed: {
        unique() {
            return function (arr, key) {
                var output = [];
                var usedKeys = {};
                for (var i = 0; i < arr.length; i++) {
                    if (!usedKeys[arr[i][key]]) {
                        usedKeys[arr[i][key]] = true;
                        output.push(arr[i]);
                    }
                }
                return output;
            }
        },
        sum() {
            return function (arr, key) {
                var sum = 0;
                for (var i = 0; i < arr.length; i++) {
                    sum += arr[i][key];
                }
                return sum;
            }
        },
        avg() {
            return function (arr, key) {
                var sum = 0;
                for (var i = 0; i < arr.length; i++) {
                    sum += arr[i][key];
                }
                return sum / arr.length;
            }
        }
    },
    methods: {
        createChart(chartId, chartData) {
            const ctx = document.getElementById(chartId);
            new Chart(ctx,
                {
                    type: chartData.type,
                    data: chartData.data,
                    options: chartData.options,
                });
        },
        formatDate: function (field, df = "DD MMM YYYY") {
            var date = dayjs(field);
            if (date.isValid()) {
                return date.format(df);
            } else return "";
        },
        formatDateShort: function (field, df = "DD MMM 'YY") {
            var date = dayjs(field);
            if (date.isValid()) {
                return date.format(df);
            } else return "";
        },
        formatTradeType: function (field) { return field === "B" ? "Buy" : "Sell"; }
    },
    filters: {
        currencyFormat: function (value) {
            if (!value) return ''
            return numeral(value).format('$0,0.00[0000]');
        },
        numberFormat: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0.00[000000]');
        },
        numberFormatSingle: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0.0');
        }
    }
});


window.Vue = Vue;
